import { NgClass, NgStyle } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Categories } from "tilby-models";
import { CashregisterStateService, Section } from "src/app/features";

@Component({
    selector: "app-category-grid-v2",
    templateUrl: "./category-grid-v2.component.html",
    standalone: true,
    imports: [NgClass, NgStyle, TranslateModule]
})
export class CategoryGridV2Component implements OnInit {
    private readonly cashregisterStateService = inject(CashregisterStateService);

    private static readonly defaultColor = "b2dfdb";

    @Input() gridCols = 0;
    @Input() maxRows = 0;
    @Input({ required: true }) categoriesSet!: Categories[];
    @Input() itemsFavorite = false;
    @Input() customClass = '';
    @Input() fontNameSize = 12;
    @Input() initCategorySelected?: Categories;
    @Output() categorySelected = new EventEmitter<Categories>();
    @Output() goToSection = new EventEmitter<Section>();

    private static readonly BORDER = 1;
    private static readonly VERTICAL_INSET = 16;
    private static readonly MIN_CHIP_HEIGHT = 44;

    protected readonly gap = 14;

    protected categorySelectedState?: Categories | 'favorites';

    ngOnInit(): void {
        if (this.initCategorySelected) {
            this.categorySelectedState = this.initCategorySelected;
        } else {
            this.categorySelectedState = this.itemsFavorite ? 'favorites' : this.categoriesSet[0];
        }
    }

    protected get stacked(): boolean {
        return this.gridCols === 1;
    }

    /** Il testo del nome occupa al massimo due righe */
    protected get chipHeight(): number {
        return Math.max(CategoryGridV2Component.MIN_CHIP_HEIGHT, Math.ceil(this.fontNameSize * 1.2 * 2 + 16));
    }

    protected get maxHeight(): number {
        const { BORDER, VERTICAL_INSET } = CategoryGridV2Component;
        return 2 * BORDER + 2 * VERTICAL_INSET + this.maxRows * this.chipHeight + (this.maxRows - 1) * this.gap;
    }

    protected categoryColor(category?: Categories): string {
        return `#${category?.color || CategoryGridV2Component.defaultColor}`;
    }

    /** Sfondo della card */
    protected categoryBackground(category?: Categories, selected = false): string {
        const color = this.categoryColor(category);
        return selected ? color : `linear-gradient(135deg, ${color}59 0%, ${color}0d 100%), var(--sys-card)`;
    }

    /** Bordo della card */
    protected categoryBorder(category?: Categories, selected = false): string {
        // return `${this.categoryColor(category)}${selected ? '' : '8c'}`;
        return `${this.categoryColor(category)}`;
    }

    /** Ombra della card */
    protected categoryShadow(category?: Categories, selected = false): string {
        return selected
            ? `0 0 0px 0px ${this.categoryColor(category)}b3, 0 1px 3px rgba(38, 38, 38, 0.25)`
            : '0 1px 2px var(--sys-cashregister-shadow-color)';
    }

    protected isSelected(category: Categories): boolean {
        return this.categorySelectedState !== 'favorites' && category.id === this.categorySelectedState?.id;
    }

    emitCategorySelection(category: Categories | { id: number, name: string }): void {
        if (this.itemsFavorite && category.id === -1) {
            this.categorySelectedState = 'favorites';
            this.goToSection.emit('favorites');
        } else {
            const selected = category as Categories;
            const amount = this.cashregisterStateService.keyboardTotalValue();
            const currentPriceList = this.cashregisterStateService.priceList();

            if (amount && selected[`department${currentPriceList == 1 ? '' : currentPriceList}_id` as keyof Categories]) {
                this.cashregisterStateService.addDynamicCategoryItemToSale$.next({
                    price: amount,
                    category: selected
                });
            } else {
                this.categorySelectedState = selected;
                this.categorySelected.emit(selected);
            }
        }
    }
}
